<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="semaltForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="account"
                    label="账号"
                    prop="account"
                    :help="formErr.account"
                    :validateStatus='!formErr.account||formErr.account==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.account"
                        @change="(e) => { formErr.account=''}"
                        @blur="(e) => {  form.account = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="userid"
                    label="userid"
                    prop="userid"
                    :help="formErr.userid"
                    :validateStatus='!formErr.userid||formErr.userid==""?"":"error"'
            >
                <a-input
                        :maxLength=100
                        v-model="form.userid"
                        @change="(e) => { formErr.userid=''}"
                        @blur="(e) => {  form.userid = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="key"
                    label="Key"
                    prop="key"
                    :help="formErr.key"
                    :validateStatus='!formErr.key||formErr.key==""?"":"error"'
            >
                <a-input
                        :maxLength=100
                        v-model="form.key"
                        @change="(e) => { formErr.key=''}"
                        @blur="(e) => {  form.key = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="total_keywords"
                    label="关键词总量"
                    prop="total_keywords"
                    :help="formErr.total_keywords"
                    :validateStatus='!formErr.total_keywords||formErr.total_keywords==""?"":"error"'
            >
<!--                oninput = "value=value.replace(/[^\d]/g,'')"-->

                <a-input-number
                        :min="0" :max="999999" class="inputNum"
                        :precision="0"
                        v-model="form.total_keywords"
                        @change="(e) => { formErr.total_keywords=''}"
                        @blur="(e) => { formErr.total_keywords='' }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :help="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
            <a-radio-group v-model="form.status"  >
                <a-radio :value="1"> 启用 </a-radio>
                <a-radio :value="0"> 停用 </a-radio>
            </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button  @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../utils/utils"
    import API from "../api";
    export default {
        name: "semaltForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig ,
                form: {
                    status:1,
                    remark:"",
                    userid:"",
                    name:"",
                    total_keywords:""
                },
                formErr: {
                    name: "",
                    status: "",
                    remark: "",
                    userid:"",
                    total_keywords:""
                },
                rules: {
                    account: [{required: true, message: "请输入账号 ", trigger: "blur"}, { whitespace: true, message: "请输入账号 " },{ type: 'email', message: '请输入邮箱的E-mail地址!'}],
                    userid: [{required: true, message: "请输入UserID ", trigger: "blur"}, {  whitespace: true, message: "请输入UserID " }],
                    key: [{required: true, message: "请输入key ", trigger: "blur"}, { whitespace: true, message: "请输入key " }],
                    total_keywords: [{required: true, message: "请输入关键词总量 ", trigger: "blur"}, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.total_keywords)} }],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
                // visible: false,
            };
        },
        watch:{
            editId: function (a) {
                if (a != "") {
                    API.Semalt. EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            // showDrawer() {
            //     this.visible = true;
            // },
            onClose() {
                this.$emit("changVisible", false);
                this.$refs.semaltForm.resetFields();
                this.form={ status:1, remark:"", userid:"", name:"", total_keywords:"" }
                this.formErr={ name: "", status: "", remark: "", userid:"", total_keywords:"" }
            },
            onSubmit() {
                let _this = this;

                this.$refs.semaltForm.validate(valid => {
                    let url
                    if (valid) {
                        this.form.id == '' || this.form.id == undefined ? url = API.Semalt.SUBMIT_ADD : url = API.Semalt.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
